// extracted by mini-css-extract-plugin
module.exports = {"container":"a2c79c7e7d--container--w_0lQ","icon":"a2c79c7e7d--icon--AgC5g","remoteness":"a2c79c7e7d--remoteness--IcApX"};